<template>
  <div class="">
    <div v-if="label != null" class="flex items-center">
      <div class="label-standard">
        <RequiredAsterisk v-if="required"></RequiredAsterisk>
        {{ label }}
      </div>
      
      <img src="https://cdn2.iconfinder.com/data/icons/officeicons/PNG/48/Help.png" 
        class="w-4 ml-4"
        v-if="tooltip != null"
        v-tooltip.top="{ html: objectId + propertyKey + 'Tooltip' }" />

      <div :id="objectId + propertyKey + 'Tooltip'" class="p-1">{{ tooltip }}</div>
    </div>

    <div :class="{ relative : true, 'form-line' : label != null }">

      <input type="text"
        class="input-standard"
        style="padding-left:20px;"
        ref="value"
        v-bind:value="localValue"
        v-on:keyup="inputTextTyped"
        v-on:blur="updateValue({
          index     : index,
          objectType: objectType,
          objectId  : objectId,
          key       : propertyKey, 
          value     : $event.target.value
        })" />

      <div style="position: absolute;top:11px;left:10px;" class="text-gray-700 text-sm">$</div>

      <div 
        v-if="copyFrom != null && $store.state[$store.state.view + 'Module'].client.applicants.length > 1" 
        style="position: absolute;top:12px;right:10px;" 
        class="text-gray-700 bg-white hover:bg-gray-300 rounded">
        <div class="" v-tooltip.bottom="{ html: label + 'TooltipOption' }">
          <svg width="18" height="18" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
            <use xlink:href="/static/img/feather-sprite.svg#chevron-down"/>
          </svg>
        </div>

        <div :id="label + 'TooltipOption'" class="p-1">
          <div class="text-xs uppercase text-gray-400 font-semibold">Copy from</div>

          <template v-for="(applicant, index) in $store.state[$store.state.view + 'Module'].client.applicants">
            <a href="#" 
              v-on:click.prevent="copyValue(applicant.id, index)"
              class="block border-t border-gray-700 mt-2 pt-2 text-sm hover:underline hover:pointer text-white no-underline">{{ getApplicantName(applicant) }}</a>
          </template>
        </div>
      </div>
    </div>

    <div v-if="subLabel != null" class="mt-2 text-sm text-gray-700">{{ subLabel }}</div>
  </div>
</template>

<script>

  import commaNumber      from 'comma-number'
  import RequiredAsterisk from '@/shared/components/form/RequiredAsterisk'

  export default {

    components : {
      RequiredAsterisk
    },

    props : {

      objectType : {
        type    : String,
        required: false
      },

      objectId : {
        type : Number,
        required : false
      },

      label : {
        type    : String,
        required: false
      },

      subLabel : {
        type    : String,
        required: false
      },

      tooltip : {
        type    : String,
        required: false
      },

      propertyKey : {
        type    : String,
        required: false
      },

      // Object name is required if data array consist of two different data model e.g "broker" & "user" and we use object name to specfiy for which model we are updating the data in this component.
      objectName : {
        type    : String,
        required: false
      },

      value : {
        // type    : String,
        required: false
      },

      updateValue : {
        type : Function,
        required : false
      },

      index : {
        type    : Number,
        required: false,
      },

      copyFrom : {
        type    : String,
        required: false
      },

      focusWhen : {
        type : Boolean, 
        required : false
      },

      required : {
        type    : Boolean,
        required: false,
        default : false
      }
    },

    computed : {
      localValue() {
        return this.value != null ? commaNumber(this.value) : null
      }
    },

    watch : {
      focusWhen : function(prev, curr) {
        if(this.focusWhen) {

          this.$refs.value.focus()
        }
      }
    },

    methods : {

      // for some components, we are updating something that is repeated via v-for.
      // For example, addresses. An applicant has multiple addresses, so we do
      // <v-for address in addresses>
      //   <InputText address>
      // But when we are doing the autosave, we actually need to know which address we are
      // updating. We can do this via index, which is passed as a prop.
      // For some, it's not repeated, so we don't need the index. So, instead of going
      // directly to updateValue, we are going via "localUpdateValue, so that we can check
      // if index exists, or not
      localUpdateValue(key, value) {
        if(this.index != null) {
          this.updateValue(this.objectType, this.index, key, value);
        }

        else if(this.objectName != null) {
          this.updateValue(this.objectName, key, value);
        } 

        else {
          this.updateValue(key, value);
        }
      },

      inputTextTyped($elem) {
        let val = ($elem.target.value).replace(/[^0-9\.]/g, '').replace(/^0([^\.])/g, '$1');

        // if (type == 'dollar_integer') {
        //   val = val.replace('.','');
        // } else {
          //Replace all but the last period
          if (val.indexOf('.') != -1) {
            var temp = val.split('.')
            var last = temp.pop()

            //Make sure that the last period has two numbers after it
            while (last.length > 2) {
              last = last.substr(last.length-2, 2);
            }

            val = temp.join('')+'.'+last;
          }
        // }

        //Comma format the number
        val = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")

        // if (element[0].name == 'spend') {
        //   scope.updateSpend(val);
        // }

        this.$refs.value.value = val

        // if there is onKeyUp method, let's call it with the value
        // if(this.onKeyup != null) {
        //   this.onKeyup(val)
        // }
      },

      copyValue(fromApplicantId, applicantIndex) {
        this.localValue = this.$store.state[this.$store.state.view + 'Module'].client.applicants[applicantIndex].person[this.copyFrom]
      }
    }
  }
</script>